<template>
  <div class="card-container">
    <common-top-form
        selectShowPower="/apppointsshopmanage/select"
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      @openAddDialog="openAddDialog"
     
    >
      <!-- 查询按钮 -->
      
      <el-form-item label="代理Id" prop="memId">
        <el-input
          type="text"
          maxlength="20"
          v-model="formModel.memId"
          placeholder="请输入代理Id"
        ></el-input>
      </el-form-item>
       <el-form-item label="机构名称" prop="activityName" v-if="this.textTatSimpleId">
         <el-select style="width: 198px" v-model="formModel.tatSimpleId">
                    <el-option
                        v-for="item in typeTwo"
                        :key="item"
                        :label="item.tatName"
                        :value="item.id"
                    >
                    </el-option>
                </el-select>
      </el-form-item>
      <!--<el-form-item label="支付方式">-->
      <!--<el-select v-model="formModel.payTypeScope">-->
      <!--<el-option-->
      <!--v-for="item in payTypeScope"-->
      <!--:key="item.dictKey"-->
      <!--:label="item.dictValue"-->
      <!--:value="item.dictKey"-->
      <!--&gt;-->
      <!--</el-option>-->
      <!--</el-select>-->
      <!--</el-form-item>-->
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
        <el-table-column
        prop="tatSimpleName"
        label="机构名称"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
          <el-table-column
        prop="activityName"
        label="活动名称"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
         <el-table-column
        prop="activityId"
        label="活动ID"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
          <el-table-column
        prop="memId"
        label="代理ID"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="creditMin"
        label="信用卡最小"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
  
      <el-table-column
        prop="debitMin"
        label="借记卡最小"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
   
      <el-table-column
        prop="wechatQrMin"
        label="微信扫码最小"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
    
      <el-table-column
        prop="alipayQrMin"
        label="支付宝最小"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
     
      <el-table-column
        prop="ysfQrMin"
        label="云闪付小额最小"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
         <el-table-column
        prop="ysfQrBigMin"
        label="云闪付大额最小"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <!-- 新增 -->
         <el-table-column
        prop="returnFirstSimAmt"
        label="首笔流量返现"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
         <el-table-column
        prop="returnOtherSimAmt"
        label="非首笔流量返现"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="otherSimStatus"
        label="是否收藏流量费"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.otherSimStatus == 0">否</span>
          <span v-else-if="scope.row.otherSimStatus == 1">是</span>
        </template>
      </el-table-column>
     
   
      <el-table-column
        prop="modifier"
        label="操作人"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="200"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="修改时间"
        min-width="200"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
    
    </common-table>
   
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
import ImageViewer from "../../dialog/ImageViewer";

import ShopService from "service/ShopService";
import TransactionService from "service/TransactionService";

import Server from "common/conf/Server";
import SelectLevel from "components/business/SelectLevel";
import privateKey from "service/constant/privateKey";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";
import activity from "service/Ainstitution";
export default {
  name: "apppointsshopmanage",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
    SelectLevel,
    ImageViewer,
  },
  data() {
    return {
      uploadUrl: Server[process.env.NODE_ENV],
      show: false,
      formModel: {
       memId: '',
         tatSimpleId: '',
      },
       typeTwo: [{ tatName: "全部", id: "" }],
      tableData: [],
      submitService: activity.brokenListNew,
      page: {},
      isPage: false,
      itemId: "",
      dialogModel: {
          activityId: '',
        memId: '',
       
        creditMin: undefined,
        
        debitMin: undefined,
      
        wechatQrMin: undefined,
    
        alipayQrMin: undefined,
      
        ysfQrMin: undefined,
        otherSimStatus: '',
        otherSimAmt: undefined,
       otherSimDays: ''
     
      },
      
      dialogRules: {
          name: [
               {
            required: true,
            message: "请输入",
          },
          ],
        creditMax: [
          {
            required: true,
            message: "请输入",
          },
        ],
        creditMin: [
          {
            required: true,
            message: "请输入",
          },
        ],
        debitMax: [
          {
            required: true,
            message: "请输入",
          },
        ],
        debitMin: [
          {
            required: true,
            message: "请输入",
          },
        ],
        wechatQrMax: [
          {
            required: true,
            message: "请输入",
          },
        ],
        wechatQrMin: [
          {
            required: true,
            message: "请输入",
          },
        ],
        alipayQrMax: [
          {
            required: true,
            message: "请输入",
          },
        ],
        alipayQrMin: [
          {
            required: true,
            message: "请输入",
          },
        ],
        ysfQrMax: [
          {
            required: true,
            message: "请输入",
          },
        ],
          ysfQrMin: [
          {
            required: true,
            message: "请输入",
          },
        ],
         otherSimAmt: [
          {
            required: true,
            message: "请输入",
          },
        ],
       otherSimDays: [
          {
            required: true,
            message: "请选择",
          },
        ],
      },
      typeList: [
        {
          dictKey: 0,
          dictValue: "否",
        },
        {
          dictKey: 1,
          dictValue: "是",
        },
      ],
      typeTwoList: [],
      isFlag: false,
      checkAll: false,
      checkedCities: [],
      couponList: [],
      loading: false,
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
    this.getTypeNames("流量费周期", (res) => {
      this.typeTwoList = res;
    });
  },
  computed: {
    submitData() {
      this.params = {
        memId: this.formModel.memId,
        tatSimpleId: this.formModel.tatSimpleId,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      return this.params;
    },
    dialogData() {
      const params = {
        name: this.dialogModel.name,
        creditMax: this.dialogModel.creditMax,
        creditMin: this.dialogModel.creditMin,
        debitMax: this.dialogModel.debitMax,
        debitMin: this.dialogModel.debitMin,
        wechatQrMax: this.dialogModel.wechatQrMax,
        wechatQrMin: this.dialogModel.wechatQrMin,
        alipayQrMax: this.dialogModel.alipayQrMax,
        alipayQrMin: this.dialogModel.alipayQrMin,
        ysfQrMax: this.dialogModel.ysfQrMax,
        ysfQrMin: this.dialogModel.ysfQrMin,
        otherSimStatus: this.dialogModel.otherSimStatus,
        otherSimAmt: this.dialogModel.otherSimAmt,
        otherSimDays: this.dialogModel.otherSimDays,
       
      };
      if (this.dialogModel.type == 2) {
        params.typeTwo = this.dialogModel.typeTwo;
      }
     
      if (this.itemId) {
        params.id = this.itemId;
      }
      return params;
    },
    dialogService() {
      return this.itemId
        ? activity.editList
        : activity.addList;
    },
    commonParams() {
      const params = {
        serverType: this.serverType,
        tatId: this.tatId,
        reqTime: new Date().format("yyyy-MM-dd HH:mm:ss"),
      };
      params.sign = encrypt(
        urlEncode(objKeySort(params)) + "&priKey=" + privateKey.priKey
      );
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId","textTatSimpleId"]),
  },
  watch: {},
  methods: {
     getTypeTwo() {
        this.doLoad(
        activity.signList,
        {
          size: 9999,
        },
        (res) => {
          this.doCheck(res, (res) => {
            console.log(res.contents.rows,'res1')
            res.contents.rows.forEach(item => {
              item.dictValue = item.id,
              item.dictKey = item.tatName
            })
            this.typeTwo = [...this.typeTwo,...res.contents.rows];
          });
        },
        "信息获取失败"
      );
    },
    load() {
      this.formModel = {
        memId: "",
        tatSimpleId: '',
      };
      this.page = this.$refs.commonTable.page;
      this.getList();
      this.getCouponList();
       this.getTypeTwo()
    },
    getCouponList() {
      this.doLoad(
        TransactionService.coupongroupmanageList,
        {
          size: 100,
        },
        (res) => {
          this.couponList = res.contents.rows;
        },
        "信息获取失败"
      );
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    handleDelete(item) {
      this.showConfirm("是否删除？")
        .then(() => {
          this.doDelete(item.id);
        })
        .catch(() => {});
    },
    doDelete(id) {
      this.doLoad(
        activity.deleteList,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    statusturns($event, scope) {
      this.doStatus($event, scope);
    },
    doStatus($event, scope) {
      this.doLoad(
       activity.udpStatus,
        {
          id: scope.id,
          status: $event,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    openAddDialog(item, flag) {
      this.itemId = item ? item.id : "";
      if (this.itemId) {
        this.isFlag = true;
        this.dialogModel = JSON.parse(JSON.stringify(item));
        this.dialogModel.couponGroupId = Number(this.dialogModel.couponGroupId);
      
      }
      this.$refs.formDialog.open();
    },
    dialogClose() {
      this.dialogModel = {
        name: '',
        creditMax: undefined,
        creditMin: undefined,
        debitMax: undefined,
        debitMin: undefined,
        wechatQrMax: undefined,
        wechatQrMin: undefined,
        alipayQrMax: undefined,
        alipayQrMin: undefined,
        ysfQrMax: undefined,
        ysfQrMin: undefined,
        otherSimStatus: '',
        otherSimAmt: undefined,
       otherSimDays: ''
      };
      this.itemId = "";
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;
        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    handleAvatarSuccess(res, file) {
      this.doCheck(res, (res) => {
        this.dialogModel.imgUrl = res.contents;
      });
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return isLt2M;
      }
      return isLt2M;
    },
    beforeAvatarUploadOther(file) {
      this.loading = true;
      console.log(file);
      const isVideo = file.type === "video/mp4";

      const isLt2M = file.size / 1024 / 1024 < 12;
      console.log(isVideo && !isLt2M, isVideo, !isLt2M);
      if (isVideo && !isLt2M) {
        this.loading = false;
        this.$message.error("上传视频大小不能超过 12MB!");
        return isLt2M;
      }
      return isLt2M;
    },
    otherError() {
      this.loading = false;
    },
    formatterTableDataTypeTwo(row, column, cellValue, index) {
      let value = "--";
      if (row.type == 3) {
        return row.couponGroupName ? row.couponGroupName : value;
      }
      if (row.type == 2) {
        return cellValue ? cellValue : value;
      }
      return value;
    },
    formatterTableDataType(row, column, cellValue, index) {
      let value = "--";
      this.typeList.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value;
    },
    handleAvatarSuccess1(res, file) {
      this.doCheck(res, (res) => {
        this.dialogModel.otherImgsUrl.push(res.contents);
        this.loading = false;
      });
    },
    handleImgClick(url) {
      this.dialogModel.otherImgsUrl = this.dialogModel.otherImgsUrl.filter(
        (item) => item !== url
      );
    },
  },
};
</script>

<style scoped>
.button {
  width: 50px;
  padding: 11px 10px;
  margin-left: 49px;
  display: block;
  float: left;
}

.text {
  width: 145px !important;
  margin-left: 12px;
  float: left;
}

.mem-name p {
  margin-bottom: 20px;
  vertical-align: middle;
  line-height: 40px;
  color: rgba(170, 170, 170, 1);
}

.mem-name p:first-child {
  display: inline-block;
  width: 90px;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
}

.chenk {
  width: 60px;
  position: relative;
  top: -61px;
  left: 189px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.iconUrl {
  width: 50px;
  height: 50px;
  margin: auto;
  overflow: hidden;
}

.alliconUrl {
  /* width: 50px;
        height: 50px; */
  display: flex;
  overflow: hidden;
  justify-content: center;
  align-items: center;
}

/deep/ .el-upload--picture-card {
  /* background-color: #fbfdff; */
  border: 0px dashed #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 35px !important;
  height: 35px !important;
  line-height: 35px !important;
  vertical-align: top;
}

/deep/ .el-upload--picture-card i {
  font-size: 40px;
  color: #8c939d;
}

.newimg {
  display: flex;
  flex-wrap: wrap;
}

.newimg div:nth-child(2) {
  margin: 0px 10px 10px 10px;
}

.newimg div:nth-child(5) {
  margin: 0px 10px 10px 10px;
}

.newimg div:nth-child(8) {
  margin: 0px 10px 10px 10px;
}

.newimg div:nth-child(11) {
  margin: 0px 10px 10px 10px;
}

.newavatar {
  width: 70px;
  height: 70px;
  display: block;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  cursor: pointer;
}

.newavatar:hover {
  width: 70px;
  height: 70px;
  border: 1px dashed red;
  border-radius: 6px;
}

.iconUrl {
  width: 50px;
  height: 50px;
  margin: 5px 5px 0px 5px;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/view/page/InstitutionList/brokerActivityTemplate.vue